import { ThemeUICSSProperties } from 'theme-ui';
import { ResponsiveSize, TextX, TextXOld, TextY } from '../../types/style';

/**
 * Return display property for responsive size.
 */
export const getDisplayProperty = (size: ResponsiveSize) => {
  switch (size) {
    case 'desktop':
      return ['none', 'none', 'block'];
    case 'tablet':
      return ['none', 'block', 'none'];
    case 'mobile':
      return ['block', 'none', 'none'];
    case 'all':
    default:
      return 'block';
  }
};

/**
 * Get size for breakpoints.
 * If responsiveLength is 0, return "all" for rendering all sizes.
 */
export const getResponsiveSize = (index: number, responsiveLength: number): ResponsiveSize => {
  if (index === 0) {
    if (responsiveLength === 0) {
      return 'all';
    }
    return 'mobile';
  } else if (index === 1) {
    return 'tablet';
  } else {
    return 'desktop';
  }
};

export const renderPaddingY = (paddingY: Queries.PaddingY) => {
  switch (paddingY) {
    case 'xs':
      return '4rem';
    case 'sm':
      return '5.6rem';
    case 'md':
      return '7.2rem';
    default:
      return 0;
  }
};

export const textXtoMarginX = (textX: TextX | TextXOld) => {
  switch (textX) {
    case 'left':
    case 'Left':
      return '0';
    case 'right':
      return '0 0 0 auto';
    case 'center':
    case 'Center':
    default:
      return 'auto';
  }
};

/**
 * Convert textX to justify-content or align-items value.
 */
export function textToAlignValue<T extends 'justifyContent' | 'alignItems'>(
  text: TextX | TextY
): ThemeUICSSProperties[T] {
  switch (text) {
    case 'top':
    case 'left':
      return 'start';
    case 'center':
      return 'center';
    case 'bottom':
    case 'right':
      return 'end';
  }
}
